/**
 * Words with the formatting a person gave them (DOP-641): bold, italic,
 * underline and strikethrough, as the memo prints them.
 */

import React from "react";

import type { DealScreeningFormatSpan } from "../../types/dealScreening";
import { formatPieces } from "./memoFormatModel";

export interface FormattedTextProps {
	text: string;
	format?: DealScreeningFormatSpan[];
	/** Where `text` starts inside the sentence `format` is over. */
	offset?: number;
}

const FormattedText: React.FC<FormattedTextProps> = ({ text, format, offset = 0 }) => {
	if (!format || format.length === 0) return <>{text}</>;
	return (
		<>
			{formatPieces(text, format, offset).map((piece, index) => {
				let node: React.ReactNode = piece.text;
				if (piece.styles.includes("strike")) node = <s>{node}</s>;
				if (piece.styles.includes("underline")) node = <u>{node}</u>;
				if (piece.styles.includes("italic")) node = <em>{node}</em>;
				if (piece.styles.includes("bold")) node = <strong>{node}</strong>;
				// Pieces are positional within an immutable sentence.
				// eslint-disable-next-line react/no-array-index-key
				return <React.Fragment key={index}>{node}</React.Fragment>;
			})}
		</>
	);
};

export default FormattedText;
